/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { Behavior } from 'backbone.marionette';

const PhoneFormatBehavior = Behavior.extend({
  onRender() {
    const $phones = this.$el.find('.phone-format');
    $phones.each((i, phone) => {
      $(phone).keydown((e) => {
        const key = e.which || e.keyCode || e.charCode;
        if (key === 8) {
          this.handleDelete(phone);
        } else {
          this.handlePreviousPhoneFormat(phone);
        }
      });

      $(phone).keyup(() => {
        this.handleTargetDisplay(phone);
      });
    });
  },

  handlePreviousPhoneFormat(phone) {
    const phoneNumber = this.$(phone).val();
    this.wasFullValidPhone = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(phoneNumber);
  },

  handleTargetDisplay(phone) {
    let phoneNumber = $(phone).val();
    const digits = phoneNumber.replace(/-/g, '');
    const isValidDigits = !isNaN(digits) && !/\+.*/.test(digits);
    const digitsLen = digits.length;
    const lastCharIsDash = phoneNumber.substr(-1) === '-';
    if (_.includes([3, 6], digitsLen) && isValidDigits && !lastCharIsDash) {
      phoneNumber += '-';
      $(phone).val(phoneNumber);
    } else if (this.wasFullValidPhone && digitsLen > 10) {
      phoneNumber = phoneNumber.replace('-', '');
      phoneNumber = phoneNumber.replace('-', '');
      $(phone).val(phoneNumber);
    }
  },

  handleDelete(phone) {
    const phoneNumber = $(phone).val();
    const digits = phoneNumber.replace(/-/g, '');
    const isValidDigits = !isNaN(digits);

    if (phoneNumber.substr(-1) === '-' && isValidDigits) {
      $(phone).val(phoneNumber.substr(0, phoneNumber.length - 1));
    }
  },
});

export default PhoneFormatBehavior;
